import { atom, useRecoilState } from "recoil";

interface MeasureSidebarState {
    isEditOpen: boolean;
    isCreateOpen: boolean;
    createMeasurePrefill: CarbonReductionMeasureInput | null;
}

const measureSidebarStateAtom = atom<MeasureSidebarState>({
    key: "measureSidebarState",
    default: {
        isEditOpen: false,
        isCreateOpen: false,
        createMeasurePrefill: null,
    },
});

const useMeasureSidebarState = () => {
    const [state, setState] = useRecoilState(measureSidebarStateAtom);

    return {
        state,
        setState,
    };
};

export default useMeasureSidebarState;
